import cx from "classnames";
import { EditableText, Flex } from "@theorgchartdev/storybook";
import React from "react";
import ActionListItem from "@/appComponents/Blocks/Composites/ActionListItem/ActionListItem";

const ReportLabel = ({
  reportName,
  reportID,
  isSelected = false,
  onRename,
  handleReportAction
}) => {
  let baseTextClass = "ocn-folder-row-text";
  let activeTextClass = isSelected ? "ocn-file-row-active-text" : null;
  let reportActions = [
    {
      dataTestId: `report-explorer-action-${reportName}-duplicate`,
      iconName: "copy",
      iconProps: { tooltipProps: { message: "Duplicate report" } },
      onClick: () =>
        handleReportAction({ reportID: reportID, data: { name: reportName } }, "duplicatereport")
    },
    {
      dataTestId: `report-explorer-action-${reportName}-delete`,
      iconName: "trash-can",
      iconProps: {
        tooltipProps: { message: "Delete report" },
        color: "error"
      },
      onClick: () => handleReportAction({ reportID: reportID }, "deletereport")
    }
  ];

  return (
    <Flex height="41px" width={"100%"}>
      <ActionListItem
        contentBefore={
          <EditableText
            dataTestId={"report-explorer-label-" + reportName}
            size={"small"}
            bold={false}
            text={reportName}
            onChange={onRename}
            eventInfo={{ ID: reportID }}
            customClass={cx(baseTextClass, activeTextClass)}
          />
        }
        actions={reportActions}
      />
    </Flex>
  );
};

export default ReportLabel;
